module.exports = __webpack_public_path__ + "static/_hunger-034c73cac42a4134196a6cf7de4f2ac8.jpg";